// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface IEmissionTestType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class EmissionTestType implements IEmissionTestType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns Admin Dir Cert EmissionTestType
	**/
    get AC(): IEmissionTestType {
        return this.FromId(10);
    }
    /**
		Returns Basic EmissionTestType
	**/
    get B(): IEmissionTestType {
        return this.FromId(11);
    }
    /**
		Returns On Board Diagnostic EmissionTestType
	**/
    get OBD(): IEmissionTestType {
        return this.FromId(12);
    }
    /**
		Returns Idle EmissionTestType
	**/
    get I(): IEmissionTestType {
        return this.FromId(13);
    }
    /**
		Returns Load EmissionTestType
	**/
    get L(): IEmissionTestType {
        return this.FromId(14);
    }
    /**
		Returns Diesel EmissionTestType
	**/
    get D(): IEmissionTestType {
        return this.FromId(15);
    }
    /**
		Returns Fleet Cert of Inspection EmissionTestType
	**/
    get Y1(): IEmissionTestType {
        return this.FromId(16);
    }
    /**
		Returns IM147 EmissionTestType
	**/
    get IM147(): IEmissionTestType {
        return this.FromId(17);
    }
    /**
		Returns Admin Reason EmissionTestType
	**/
    get AR(): IEmissionTestType {
        return this.FromId(20);
    }
    /**
		Returns Early EmissionTestType
	**/
    get ER(): IEmissionTestType {
        return this.FromId(30);
    }
    /**
		Returns AZ Veh Out Of State EmissionTestType
	**/
    get OS(): IEmissionTestType {
        return this.FromId(40);
    }
    /**
		Returns Military Exemption EmissionTestType
	**/
    get ME(): IEmissionTestType {
        return this.FromId(50);
    }
    /**
		Returns Technical Difficulties EmissionTestType
	**/
    get TD(): IEmissionTestType {
        return this.FromId(60);
    }
    /**
		Returns Pima OBD EmissionTestType
	**/
    get Two(): IEmissionTestType {
        return this.FromId(61);
    }
    /**
		Returns Maricopa OBD EmissionTestType
	**/
    get O(): IEmissionTestType {
        return this.FromId(62);
    }
    /**
		Returns Code 52 Exemption EmissionTestType
	**/
    get FiftyTwo(): IEmissionTestType {
        return this.FromId(63);
    }
    /**
		Returns Two Year Exemption EmissionTestType
	**/
    get Y2(): IEmissionTestType {
        return this.FromId(64);
    }
    /**
		Returns Certificate of Inspect 1 Year EmissionTestType
	**/
    get CI1(): IEmissionTestType {
        return this.FromId(65);
    }
    /**
		Returns Certificate of Inspect 2 Year EmissionTestType
	**/
    get CI2(): IEmissionTestType {
        return this.FromId(66);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('10', { id: 10, value: 'AC', displayValue: 'Admin Dir Cert', description: 'Administrative Director\'s Certificate', sortOrder: 999999, active: true });
        this._dictionary.add('11', { id: 11, value: 'B', displayValue: 'Basic', description: 'Basic', sortOrder: 999999, active: true });
        this._dictionary.add('12', { id: 12, value: 'OBD', displayValue: 'On Board Diagnostic', description: 'On Board Diagnostic', sortOrder: 999999, active: true });
        this._dictionary.add('13', { id: 13, value: 'I', displayValue: 'Idle', description: 'Idle', sortOrder: 999999, active: true });
        this._dictionary.add('14', { id: 14, value: 'L', displayValue: 'Load', description: 'Load', sortOrder: 999999, active: true });
        this._dictionary.add('15', { id: 15, value: 'D', displayValue: 'Diesel', description: 'Diesel', sortOrder: 999999, active: true });
        this._dictionary.add('16', { id: 16, value: 'Y1', displayValue: 'Fleet Cert of Inspection', description: 'Fleet Certificate of Inspection', sortOrder: 999999, active: true });
        this._dictionary.add('17', { id: 17, value: 'IM147', displayValue: 'IM147', description: 'IM147', sortOrder: 999999, active: true });
        this._dictionary.add('20', { id: 20, value: 'AR', displayValue: 'Admin Reason', description: 'Administrative Reason', sortOrder: 999999, active: true });
        this._dictionary.add('30', { id: 30, value: 'ER', displayValue: 'Early', description: 'Early', sortOrder: 999999, active: true });
        this._dictionary.add('40', { id: 40, value: 'OS', displayValue: 'AZ Veh Out Of State', description: 'AZ Vehicle Out Of State', sortOrder: 999999, active: true });
        this._dictionary.add('50', { id: 50, value: 'ME', displayValue: 'Military Exemption', description: 'Military Exemption', sortOrder: 999999, active: true });
        this._dictionary.add('60', { id: 60, value: 'TD', displayValue: 'Technical Difficulties', description: 'Tehnical Difficulties', sortOrder: 999999, active: true });
        this._dictionary.add('61', { id: 61, value: '2', displayValue: 'Pima OBD', description: 'Pima OBD', sortOrder: 999999, active: true });
        this._dictionary.add('62', { id: 62, value: 'O', displayValue: 'Maricopa OBD', description: 'Maricopa OBD', sortOrder: 999999, active: true });
        this._dictionary.add('63', { id: 63, value: '52', displayValue: 'Code 52 Exemption', description: 'Code 52 Exemption', sortOrder: 999999, active: true });
        this._dictionary.add('64', { id: 64, value: 'Y2', displayValue: 'Two Year Exemption', description: 'Two Year Exemption', sortOrder: 999999, active: true });
        this._dictionary.add('65', { id: 65, value: 'CI1', displayValue: 'Certificate of Inspect 1 Year', description: 'Certificate of Inspect 1 Year', sortOrder: 999999, active: true });
        this._dictionary.add('66', { id: 66, value: 'CI2', displayValue: 'Certificate of Inspect 2 Year', description: 'Certificate of Inspect 2 Year', sortOrder: 999999, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IEmissionTestType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IEmissionTestType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IEmissionTestType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IEmissionTestType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): IEmissionTestType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
